import { requestJson } from "../lib/request";
import { commonParams } from "@/config/common";
import { LanguageContent } from '../lib/util/lang'

const langSuffix = LanguageContent.getPaaSJsonSuffix()

class News {
    static base_url = `${ commonParams.PAAS_CONFIG }/news/`

    static getNewsList(){
        return requestJson(`${this.base_url}${langSuffix}/news_list.json`)
    }

    static getNewsType() {
        return requestJson(`${this.base_url}news_type_list.json`)
    }

    static getNewsDetail(id) {
        return requestJson(`${this.base_url}${langSuffix}/${id}.json`)
    }

    static getNewsListJson() {
        return requestJson(`${this.base_url}${langSuffix}/news_list.json`)
    }
}

export { News }


// WEBPACK FOOTER //
// ./src/models/news.js